import { EntitySubscriberInterface, EventSubscriber, InsertEvent } from 'typeorm'

import { checkDomain } from '@things-factory/operato-license-checker'
import { Domain } from '@things-factory/shell'

import { LicenseError } from '../../errors/license-error.js'

@EventSubscriber()
export class DomainPermissionSubscriber implements EntitySubscriberInterface<Domain> {
  listenTo() {
    return Domain
  }
  /**
   * Called before domain insertion.
   */
  async afterInsert(event: InsertEvent<Domain>) {
    var entityManager = event.manager

    var count = (await entityManager.createQueryBuilder().select('id').from(Domain, 'domain').getCount()) + 1

    if (!checkDomain(count)) {
      throw new LicenseError({
        errorCode: LicenseError.ERROR_CODES.VERIFICATION_ERROR
      })
    }
  }
}
